import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

// 配置
const routes = [
    {
        name: "dataset-list",
        path: "/",
        component: () => import(/* webpackChunkName: "layout" */ '../views/数据集列表')
    },
    {
        name: "medata",
        path: "/medata",
        component: () => import(/* webpackChunkName: "layout" */ '../views/元数据')
    },
    {
        path: "*",
        redirect: "/"
    }
];

// 声明路由
const router = new VueRouter({
    base: process.env.NODE_ENV === 'production' ? 'web' : "./",
    routes
});

export default router;